var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ext-goods-nav-box"},[_c('ul',_vm._l((_vm.nav_list),function(vo,index){return _c('li',{key:index},[_c('a',{class:[vo.id==_vm.select_id ? 'select' : ''],on:{"click":function($event){return _vm.set_link(vo.id)}}},[_vm._v(_vm._s(vo.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa0d8e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftnav/leftnav.vue
// module id = null
// module chunks = 